<template>
  <div class="page-wrap">
    <router-view></router-view>
  </div>
</template>

<script>
import store from '@app/store';

export default {  
  async beforeRouteEnter({ name }, from, next) {
    store.commit('navigation/setSideTree', [
      { title: 'Международный классификатор болезней', name: 'dictionary.mkb10' },
      { title: 'Государственный реестр лекарственных средств', name: 'dictionary.grls' }
    ]);
    next();
  },
  beforeRouteLeave(to, from, next) {
    store.commit('navigation/setSideTree', []);
    next();
  },
  mounted() {
    if (!this.$store.state.auth.is_auth){
      this.$router.push('/');
      helper.toastErrorAuth();
    }
  }
};
</script>

<style scoped>
.page-wrap {
  width: 90%;
  padding: 2rem;
  margin: auto;
}
</style>